// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar-index__avatar--VsTEv","mini":"Avatar-index__mini--sfshT","small":"Avatar-index__small--W5nSP","gravatar":"Avatar-index__gravatar--oadAf"};